import ErrorPage from "components/ErrorPage"
import { context } from "global/Context/context"
import React, { useContext } from "react"

interface GrowthspaceRouteProps {
  personal?: React.ReactNode
  suraasaSure?: React.ReactNode
}

const GrowthspaceRoute: React.FC<GrowthspaceRouteProps> = ({
  personal,
  suraasaSure,
}) => {
  const { currentGrowthspace, isAuthenticated, listGrowthspaceQuery } =
    useContext(context)

  if (!isAuthenticated) return personal ?? <ErrorPage errorStatus={404} />

  if (!currentGrowthspace && !listGrowthspaceQuery?.isLoading)
    return (
      <ErrorPage
        errorStatus={404}
        title="Oops! Something went wrong"
        description="We’re having trouble loading your details. Please refresh the page or try again later."
      />
    )

  const isSuraasaSure = !!currentGrowthspace?.organization

  if (isSuraasaSure) {
    return suraasaSure ?? <ErrorPage errorStatus={404} />
  }
  return personal ?? <ErrorPage errorStatus={404} />
}

export default GrowthspaceRoute
